import React from 'react';
import { Title } from './components/Title';
import './SearchPage.css';
import { Search } from './components/SearchSpace';

export default function SearchPage() {
  return (

    <div className="searchPage-container">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css" />
      <link rel="stylesheet" href="https://cdn.es.gov.br/fonts/font-awesome/css/font-awesome.min.css" />

      <Title />

      <Search />

    </div>

  );
}
